import React, { HTMLAttributes } from 'react';

import { LargeRadio } from '../LargeRadio/LargeRadio';

const RatingDesktop = ({ onChange }: HTMLAttributes<HTMLDivElement>): JSX.Element => (
  <div className='space-x-4 hidden md:inline-block' onChange={onChange}>
    {Array.from(Array(11)).map((_, i) => (
      <LargeRadio name='feedback' value={i} label={`${i}`} key={`radio-${i.toString()}`} />
    ))}
  </div>
);

export { RatingDesktop };
